declare namespace $ {

	type $mol_text__text_bog_feedback2_form_1 = $mol_type_enforce<
		ReturnType< $bog_feedback2_form['prompt'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_textarea__hint_bog_feedback2_form_2 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_textarea['hint'] >
	>
	type $mol_textarea__value_bog_feedback2_form_3 = $mol_type_enforce<
		ReturnType< $bog_feedback2_form['draft_text'] >
		,
		ReturnType< $mol_textarea['value'] >
	>
	type $mol_string__hint_bog_feedback2_form_4 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__value_bog_feedback2_form_5 = $mol_type_enforce<
		ReturnType< $bog_feedback2_form['draft_contact'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_button_major__title_bog_feedback2_form_6 = $mol_type_enforce<
		ReturnType< $bog_feedback2_form['submit_title'] >
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__click_bog_feedback2_form_7 = $mol_type_enforce<
		ReturnType< $bog_feedback2_form['submit'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_text__text_bog_feedback2_form_8 = $mol_type_enforce<
		ReturnType< $bog_feedback2_form['entry_row_text'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_paragraph__title_bog_feedback2_form_9 = $mol_type_enforce<
		ReturnType< $bog_feedback2_form['entry_row_reply_header_text'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_text__text_bog_feedback2_form_10 = $mol_type_enforce<
		ReturnType< $bog_feedback2_form['entry_row_reply_text'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_view__sub_bog_feedback2_form_11 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_textarea__hint_bog_feedback2_form_12 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_textarea['hint'] >
	>
	type $mol_textarea__value_bog_feedback2_form_13 = $mol_type_enforce<
		ReturnType< $bog_feedback2_form['entry_row_reply_draft'] >
		,
		ReturnType< $mol_textarea['value'] >
	>
	type $mol_button_major__title_bog_feedback2_form_14 = $mol_type_enforce<
		ReturnType< $bog_feedback2_form['entry_row_reply_submit_title'] >
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__click_bog_feedback2_form_15 = $mol_type_enforce<
		ReturnType< $bog_feedback2_form['entry_row_reply_submit'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_view__sub_bog_feedback2_form_16 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__title_bog_feedback2_form_17 = $mol_type_enforce<
		ReturnType< $bog_feedback2_form['entry_row_reply_toggle_title'] >
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_bog_feedback2_form_18 = $mol_type_enforce<
		ReturnType< $bog_feedback2_form['entry_row_reply_toggle'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_view__sub_bog_feedback2_form_19 = $mol_type_enforce<
		ReturnType< $bog_feedback2_form['entry_row_reply_sub'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_section__title_bog_feedback2_form_20 = $mol_type_enforce<
		ReturnType< $bog_feedback2_form['entry_row_contact'] >
		,
		ReturnType< $mol_section['title'] >
	>
	type $mol_section__content_bog_feedback2_form_21 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_section['content'] >
	>
	type $mol_section__title_bog_feedback2_form_22 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_section['title'] >
	>
	type $mol_section__content_bog_feedback2_form_23 = $mol_type_enforce<
		ReturnType< $bog_feedback2_form['entry_rows'] >
		,
		ReturnType< $mol_section['content'] >
	>
	type $mol_status__message_bog_feedback2_form_24 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_status['message'] >
	>
	export class $bog_feedback2_form extends $mol_page {
		Close( ): any
		prompt( ): string
		Prompt( ): $mol_text
		draft_text( next?: string ): string
		Entry_my( ): $mol_textarea
		draft_contact( next?: string ): string
		Contact_field( ): $mol_string
		submit_title( ): string
		submit( next?: any ): any
		Submit( ): $mol_button_major
		entry_row_contact( id: any): string
		entry_row_text( id: any): string
		Entry_row_text( id: any): $mol_text
		entry_row_reply_header_text( id: any): string
		Entry_row_reply_header( id: any): $mol_paragraph
		entry_row_reply_text( id: any): string
		Entry_row_reply_text( id: any): $mol_text
		Entry_row_reply_display( id: any): $mol_view
		entry_row_reply_draft( id: any, next?: string ): string
		Entry_row_reply_input( id: any): $mol_textarea
		entry_row_reply_submit_title( id: any): string
		entry_row_reply_submit( id: any, next?: any ): any
		Entry_row_reply_submit( id: any): $mol_button_major
		Entry_row_reply_form( id: any): $mol_view
		entry_row_reply_toggle_title( id: any): string
		entry_row_reply_toggle( id: any, next?: any ): any
		Entry_row_reply_toggle( id: any): $mol_button_minor
		entry_row_reply_sub( id: any): readonly(any)[]
		Entry_row_reply_wrap( id: any): $mol_view
		Entry_row( id: any): $mol_section
		entry_rows( ): readonly(any)[]
		Entries( ): $mol_section
		Head( ): any
		feedback_id( ): string
		registry_link( ): string
		title( ): string
		prompt_title( ): string
		prompt_like( ): string
		prompt_better( ): string
		prompt_future( ): string
		submit_send( ): string
		submit_update( ): string
		anonymous( ): string
		reply_send( ): string
		reply_update( ): string
		reply_open( ): string
		reply_cancel( ): string
		reply_edit( ): string
		not_ready( ): string
		tools( ): readonly(any)[]
		body( ): readonly(any)[]
		Not_configured( ): $mol_status
	}
	
}

//# sourceMappingURL=form.view.tree.d.ts.map